// context/LoadingContext.js
import React, { createContext, useState, useCallback, useMemo } from 'react';

export const LoadingContext = createContext(undefined);

export function LoadingProvider({ children }) {
  const [loadingState, setLoadingState] = useState({});

  const startLoading = useCallback((key) => {
    setLoadingState(prev => {
      if (prev[key]) return prev;
      return { ...prev, [key]: true };
    });
  }, []);

  const stopLoading = useCallback((key) => {
    setLoadingState(prev => {
      if (!prev[key]) return prev;
      return { ...prev, [key]: false };
    });
  }, []);

  const isLoadingKey = useCallback((key) => {
    return Boolean(loadingState[key]);
  }, [loadingState]);

  const contextValue = useMemo(() => ({
    isLoading: loadingState,
    startLoading,
    stopLoading,
    isLoadingKey
  }), [loadingState, startLoading, stopLoading, isLoadingKey]);

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
}